import { createEntityAdapter } from '@reduxjs/toolkit';

import { Question } from './types';

export const questionAdapter = createEntityAdapter<Question>();

export const {
  selectIds: selectQuestionIds,
  selectEntities: selectQuestionEntities,
  selectAll: selectAllQuestions,
  selectById: selectQuestionById,
  selectTotal: selectTotalQuestions,
} = questionAdapter.getSelectors((state: any) => state.questions);
